
// TODO: Expand supported mime types
export const googleNativeMimeTypeMap: Record<string, string> = {
  'application/vnd.google-apps.document':
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.google-apps.spreadsheet':
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.google-apps.file': 'application/pdf',
  'application/vnd.google-apps.presentation': 'application/pdf',
  'application/vnd.google-apps.script': 'text/markdown',
  'application/vnd.google-apps.folder': 'application/vnd.google-apps.folder',
};

// File extensions for Google native formats after export
export const googleNativeExtensionMap: Record<string, string> = {
  'application/vnd.google-apps.document': '.docx',
  'application/vnd.google-apps.spreadsheet': '.xlsx',
  'application/vnd.google-apps.file': '.pdf',
  'application/vnd.google-apps.presentation': '.pdf',
  'application/vnd.google-apps.script': '.md',
};

export const isGoogleNativeFormat = (mimeType: string) =>
  mimeType.startsWith('application/vnd.google-apps.');

// Google native files don't have extensions in their names, so we need to add them
export const getFileNameWithExtension = (fileName: string, mimeType: string, isFolder: boolean) => {
  if (isFolder) {
    return fileName;
  }
  if (isGoogleNativeFormat(mimeType)) {
    const extension = googleNativeExtensionMap[mimeType] || '.pdf';
    return `${fileName}${extension}`;
  }
  return fileName;
};

// Google native formats (Docs, Sheets, Slides) must be exported to a different format
  // Regular files (PDFs, images, etc.) use alt=media for direct download
  export const createDownloadLink = (fileId: string, mimeType: string, isFolder: boolean) => {
    if (isFolder) {
      return `https://www.googleapis.com/drive/v2/files`;
    }
    if (isGoogleNativeFormat(mimeType)) {
      const exportMimeType = googleNativeMimeTypeMap[mimeType] || 'application/pdf';
      return `https://www.googleapis.com/drive/v3/files/${fileId}/export?mimeType=${exportMimeType}`;
    }
    return `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;
  };